import { Task, TaskStatus, TaskSystemStatusName } from '@jms/model';
import type { EvidenceDateFormatter } from '@workbuddy/entities/work.task/evidence.exception';
import type { HoverCardRow } from '@workbuddy/ui/v2/components/hover.card';
import { ItemCompletion } from './item.completion.card';

/** Not Required and Cannot Complete mirror the legacy Completed, so only the stamp's system name tells them from Completed; an unstamped old task counts as Completed (WBS-13065). */
export function resolveItemCompletion(task: Pick<Task, 'status' | 'taskStatus' | 'completedOn' | 'completedBy'> | null | undefined, formatDate: EvidenceDateFormatter): ItemCompletion {

  if (!task) return { state: 'na' };
  if (task.status !== TaskStatus.Completed) return { state: 'pending' };

  const stamp = task.taskStatus;
  const closedWithoutWork = !!stamp?._id && stamp.systemName !== TaskSystemStatusName.Completed;
  const rows: HoverCardRow[] = [
    { label: 'Status', value: stamp?.name ?? 'Completed' },
    ...(closedWithoutWork && stamp.reason?.name ? [{ label: 'Reason', value: stamp.reason.name }] : []),
    ...(closedWithoutWork && stamp.note ? [{ label: 'Note', value: stamp.note }] : []),
    { label: 'Completed On', value: task.completedOn ? formatDate(task.completedOn) : 'Not Set' },
    { label: 'Completed By', value: task.completedBy?.name ?? 'Not Set' },
  ];

  return {
    state: closedWithoutWork ? 'resolved' : 'complete',
    rows,
  };
}
